import { render, staticRenderFns } from "./NotificationSummary.vue?vue&type=template&id=9bbf86ec&scoped=true&"
import script from "./NotificationSummary.vue?vue&type=script&lang=js&"
export * from "./NotificationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbf86ec",
  null
  
)

export default component.exports